import { UseMutationOptions, useMutation } from 'react-query';
import { updateUser } from '../data';
import { Team } from '../types';

type UpdateUserMutationOptions = UseMutationOptions<Team, Error, Team>;

export const useUpdateUserMutation = (options?: UpdateUserMutationOptions) => {
  return useMutation(updateUser, { ...options });
};
